import { useLabelsSessionWorkspace } from "./useLabelsSessionWorkspace";
import { SystemState } from "../../shared/components/SystemState";
import { LabelModule } from "./LabelModule";
import { useLabelPinWorkspace, useLabelPinLogout } from "./useLabelPinWorkspace";
import { LabelPinForm } from "./views/LabelPinForm";
import "./label-access.css";

/**
 * Etiket modülünün oturum sınırı. Etiket iş akışındaki roller yalnız
 * /api/labels/session yanıtından alınır; ana uygulama rolleri burada
 * satış, pazarlama, kalite veya baskı rolüne dönüştürülmez.
 */
export function LabelsModule() {
  const {session, loading, fault, api, refresh} = useLabelsSessionWorkspace();
  const pin = useLabelPinWorkspace({ api, refresh });

  if (loading) {
    return (
      <SystemState
        mode="page"
        tone="loading"
        title="Etiket çalışma alanı hazırlanıyor"
        description="Etiket iş akışı rolünüz ve kayıt kapsamınız doğrulanıyor."
      />
    );
  }

  if (fault) {
    return (
      <SystemState
        mode="page"
        tone="danger"
        title="Etiket oturumu alınamadı"
        description={fault.message}
        primaryAction={{ label: "Yeniden dene", onClick: refresh }}
      />
    );
  }

  if (session?.pinLoginAvailable && !session.actor) {
    return <main className="anl-label-shell"><LabelPinForm workspace={pin} /></main>;
  }

  if (!session?.actor) {
    return (
      <SystemState
        mode="page"
        tone="warning"
        title={session?.pinMode === "persistent" ? "Etiket PIN girişi henüz açılmadı" : "Etiket rolü tanımlı değil"}
        description={session?.pinMode === "persistent" ? "Sistem yöneticisi PIN girişini etkinleştirdiğinde bu ekrandan devam edebilirsiniz." : "Etiket iş akışında size atanmış bir rol bulunmuyor. Rol eşleştirmesi sistem yöneticisi tarafından yapılmalıdır."}
        primaryAction={{ label: "Yetkiyi yeniden kontrol et", onClick: refresh }}
      />
    );
  }

  return <>
    {session.authenticationMethod === "pin" ? <div className="anl-label-session-actions"><LabelPinLogout api={api} refresh={refresh} /></div> : null}
    <LabelModule api={api} session={session} />
  </>;
}

function LabelPinLogout({ api, refresh }: { api: ReturnType<typeof useLabelsSessionWorkspace>["api"]; refresh: () => void }) {
  const { busy, error, logout } = useLabelPinLogout({ api, refresh });
  return <><button className="anl-button is-text" disabled={busy} onClick={() => void logout()}>{busy ? "Çıkış yapılıyor…" : "Etiket oturumundan çık"}</button>{error ? <span role="alert">{error}</span> : null}</>;
}
